// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/notams.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/notams/notams.js';

mount([g0]);
